import React, { Component } from 'react';
import Header from '../../../Components/V2/Header';
import Footer from '../../../Components/V2/Footer';
import FormLogin from '../../../Containers/V2/FormLogin';

export default class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className='home-page background12'>
        <Header />
        <main className='position-relative background12'>
          <FormLogin />
        </main>
        <Footer />
      </div>
    );
  }
}
